import * as React from 'react';



export default class Fax extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <defs>
                <path id="a" d="M0 13.067h13.319V.254H0z"/>
                <path id="c" d="M0 13.067h13.319V.254H0z"/>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path fill="#53A9DE" d="M12.593 12.678h1.195v-7.56h-1.195z"/>
                <g transform="translate(1 1.68)">
                    <path stroke="" strokeLinecap="round" strokeLinejoin="round" d="M2.3 11.348H.465v-7.92h12.386v7.92H5.385"/>
                    
                    <path stroke="" strokeLinecap="round" strokeLinejoin="round" d="M2.542 12.6H5.26V5.117H2.542z" mask="url(#b)"/>
                </g>
                <path stroke="" strokeLinecap="round" strokeLinejoin="round" d="M8.495 6.797h3.669"/>
                <g transform="translate(1 1.68)">
                    <path fill="" d="M7.961 6.832a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M9.796 6.832a.467.467 0 1 1-.935-.001.467.467 0 0 1 .935.001M11.63 6.832a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0M7.961 8.374a.467.467 0 1 1-.935-.001.467.467 0 0 1 .935.001M9.796 8.374a.467.467 0 1 1-.932-.002.467.467 0 0 1 .932.002M11.63 8.374a.467.467 0 1 1-.935-.001.467.467 0 0 1 .935.001M7.961 9.916a.467.467 0 1 1-.933 0 .467.467 0 0 1 .933 0M9.796 9.916a.467.467 0 1 1-.935-.002.467.467 0 0 1 .935.002M11.63 9.916a.467.467 0 1 1-.934 0 .467.467 0 0 1 .934 0"/>
                    <path stroke="" strokeLinecap="round" strokeLinejoin="round" d="M2.299 3.274h8.621V.721H2.299z" mask="url(#d)"/>
                </g>
            </g>
        </svg>
    )
  }
}
